module.exports = __webpack_public_path__ + "img/voltage2.433bdf9c.png";